import script from "./AdvancedError.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdvancedError.vue?vue&type=script&setup=true&lang=ts"

import "./AdvancedError.vue?vue&type=style&index=0&id=cf9739e8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf9739e8"]])

export default __exports__